/* eslint-disable jira/filename-case */
import { isSynthetic } from '@jira/platform__is-synthetic/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const isRestrictedFromPostOfficeSynthetic = (): boolean => {
	if (fg('post-office-enable-placement-synthetic-restriction')) {
		if (isSynthetic()) {
			// permanent gate containing a segment of Post Office Pollinator accounts
			// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/segments/segment%3Apost-office-pollinator-accounts
			return !fg('post-office-is-post-office-synthetic');
		}
	}

	return false;
};
